var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import Draggable from 'react-draggable';
import { GlobalStyle } from './global-style';
import { DialogTitle } from './dialog-title';
import { BinIconGlyph } from '@shapeable/icons';
var cls = classNames('dialog');
export var DialogDefaultProps = {
  maxWidth: "600px",
  padBody: true
};
// -------- Styles ---------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    background: ", ";\n    box-shadow: 0px 2px 4px -3px rgba(0, 0, 0, 0.2); \n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    background: ", ";\n    box-shadow: 0px 2px 4px -3px rgba(0, 0, 0, 0.2); \n  "])), theme.FONT('sans'), theme.FONT_SIZE(16), theme.COLOR('canvas')),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "])), props.maxWidth);
  })
});
var TitleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1em;\n    cursor: -webkit-grab;\n\n    &:active {\n      cursor: -webkit-grabbing;\n    }\n\n    padding: ", " ", ";\n  "], ["\n    font-size: 1em;\n    cursor: -webkit-grab;\n\n    &:active {\n      cursor: -webkit-grabbing;\n    }\n\n    padding: ", " ", ";\n  "])), theme.UNIT(1), theme.UNIT(3)),
  landscape: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "]))),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", " ", ";\n    font-size: 1em;\n  "], ["\n    padding: ", " ", ";\n    font-size: 1em;\n  "])), theme.UNIT(2), theme.UNIT(4)),
  desktop: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n\n    ", "\n\n  "], ["\n    ", "\n\n    ", "\n\n  "])), function (props) {
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      align-items: center;\n      flex-direction: column;\n      display: flex;\n      height: 100%;\n      line-height: 1.4em;\n      justify-content: center;\n      color: ", ";\n      border-top: 1px solid ", ";\n    "], ["\n      align-items: center;\n      flex-direction: column;\n      display: flex;\n      height: 100%;\n      line-height: 1.4em;\n      justify-content: center;\n      color: ", ";\n      border-top: 1px solid ", ";\n    "])), theme.COLOR('text'), theme.COLOR('line-subtle'));
  }, function (props) {
    return props.pad && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      background: ", ";\n      padding: ", ";\n    "], ["\n      background: ", ";\n      padding: ", ";\n    "])), theme.COLOR('light'), theme.UNIT(4));
  }),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.pad && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme.UNIT(6));
  })
});
var ButtonContainerStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    background: #FAFAFA;\n    border-top: 1px solid ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: ", ";\n  "], ["\n    background: #FAFAFA;\n    border-top: 1px solid ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: ", ";\n  "])), theme.COLOR('line-subtle'), theme.UNIT(4))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: styled(DialogTitle)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  ButtonContainer: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ButtonContainerStyles)
};
export var Dialog = function (props) {
  var className = props.className,
    maxWidth = props.maxWidth,
    padBody = props.padBody,
    children = props.children,
    controls = props.controls,
    button = props.button,
    titleProps = __rest(props, ["className", "maxWidth", "padBody", "children", "controls", "button"]);
  return React.createElement(Draggable, {
    handle: ".handle"
  }, React.createElement(My.Container, {
    maxWidth: maxWidth,
    className: className
  }, React.createElement(GlobalStyle, null), React.createElement(My.Title, __assign({
    icon: BinIconGlyph,
    className: "handle"
  }, titleProps)), React.createElement(My.Body, {
    pad: padBody
  }, children), controls, button && React.createElement(My.ButtonContainer, {
    className: "handle"
  }, button)));
};
Dialog.defaultProps = DialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;